import React from 'react';
import QR from './QR';
import Packet from './Packet';
import QrScanner from './QrScanner';
import { Redirect } from 'react-router-dom';
// import FakeQrScanner from "./FakeQrScanner";
import ProgressBar from 'react-bootstrap/ProgressBar';

class Send extends React.Component {
  constructor(props) {
    super(props);
    this.file = this.props.file;
    this.reader = new FileReader();
    this.state = {
      showCamera: false,
      redirect: false,
      dataBytes: 150,
      error: null,
      result: null,
      progress: null,
      isEOF: false,
      cursor: 0,
      fileHash: 0,
      sequenceNumber: 0,
      currentPacket: null,
      analytics: [],
    };
    if (this.props.file) {
      this.reader.onprogress = this.handleProgress.bind(this);
      this.reader.onload = this.handleLoad.bind(this);
      this.reader.onerror = this.handleError.bind(this);
      this.reader.readAsArrayBuffer(this.props.file);
    }
    this.updatePacket = this.updatePacket.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.inputRef = React.createRef();
    this.updateDataBytes = this.updateDataBytes.bind(this);
    this.toggleCamera = this.toggleCamera.bind(this);
  }

  toggleCamera() {
    this.setState((state) => ({ showCamera: !state.showCamera }));
  }

  handleProgress(e) {
    this.setState({ progress: e });
  }

  handleLoad() {
    console.log(this.reader.result);
    const packet = Packet.encodeInitialPacket(this.props.file);
    const now = Date.now();
    this.setState((state) => ({
      analytics: state.analytics.concat([{ time: now, bytes: 0 }]),
      fileHash: packet.fileHash,
      sequenceNumber: packet.sequenceNumber,
      currentPacket: packet,
      result: this.reader.result,
    }));
  }

  handleError() {
    this.setState({ error: this.reader.error });
  }

  updateDataBytes() {
    this.setState({ dataBytes: parseInt(this.inputRef.current.value) });
  }

  updatePacket() {
    const now = Date.now();
    // File not yet loaded.
    if (!this.state.result) {
      return;
    }
    // EOF packet has been acked.
    if (this.state.isEOF) {
      this.setState({
        redirect: true,
        error: null,
        result: null,
        progress: null,
        isEOF: false,
        cursor: 0,
        fileHash: 0,
        sequenceNumber: 0,
        currentPacket: null,
      });
      return;
    }
    // We've reached the end of the file.
    if (this.state.cursor >= this.state.result.byteLength) {
      this.setState((state) => ({
        currentPacket: Packet.encodeEofPacket(
          state.fileHash,
          state.sequenceNumber + 1
        ),
        sequenceNumber: state.sequenceNumber + 1,
        isEOF: true,
        analytics: state.analytics.concat([
          { time: now, bytes: state.currentPacket.data.byteLength || 0 },
        ]),
      }));
      return;
    }
    this.setState((state) => ({
      currentPacket: Packet.encodeDataPacket(
        state.fileHash,
        state.sequenceNumber + 1,
        state.result.slice(state.cursor, state.cursor + state.dataBytes)
      ),
      cursor: state.cursor + state.dataBytes,
      sequenceNumber: state.sequenceNumber + 1,
      analytics: state.analytics.concat([
        { time: now, bytes: state.currentPacket.data.byteLength || 0 },
      ]),
    }));
  }

  handleScan(buffer) {
    const packet = Packet.decodeArrayBuffer(buffer);
    if (!packet) {
      console.log('received empty packet', buffer);
      return;
    }
    console.log('received', packet.toString());
    if (packet.packetType === Packet.packetTypes.ACK_PACKET) {
      if (packet.fileHash === this.state.fileHash) {
        if (packet.sequenceNumber === this.state.sequenceNumber) {
          console.log('Received ACK packet for', this.state.sequenceNumber);
          this.updatePacket();
        } else {
          console.log(
            `Received ACK for different sequenceNumber, expected[${this.state.sequenceNumber}] got[${packet.sequenceNumber}]`
          );
        }
      } else {
        console.log(
          `Received ACK for different fileHash, expected[${this.state.fileHash}] got[${packet.fileHash}]`
        );
      }
    } else {
      console.log(
        `Received non ACK packet, expected[${Packet.packetTypes.ACK_PACKET}] got[${packet.packetType}]`
      );
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/' />;
    }
    let maybeQr = <p>Loading file...</p>;
    if (this.state.result) {
      console.log('rendering', this.state.currentPacket.toString());
      const progress = this.state.cursor / this.state.result.byteLength;
      const lastFewPacketAnalytics = this.state.analytics.slice(-3).reduce(
        (res, next) => ({
          minTime: Math.min(next.time, res.minTime),
          maxTime: Math.max(next.time, res.maxTime),
          bytes: next.bytes + res.bytes,
        }),
        { minTime: Number.MAX_SAFE_INTEGER, maxTime: 0, bytes: 0 }
      );
      console.log(lastFewPacketAnalytics);
      const transferRate =
        lastFewPacketAnalytics.bytes /
        ((lastFewPacketAnalytics.maxTime - lastFewPacketAnalytics.minTime) /
          1000);
      maybeQr = (
        <div>
          <QR
            {...this.props}
            data={this.state.currentPacket.toBinaryString()}
            width={Math.floor(
              Math.min(window.innerWidth, window.innerHeight) * 0.9
            )}
          />
          <p>Transfer Rate: {transferRate.toFixed(2)} bytes/sec</p>
          <ProgressBar
            min={0}
            max={1}
            now={progress}
            label={`${Math.floor(progress * 100)}%`}
          />
          <QrScanner
            handleScan={this.handleScan}
            hidden={!this.state.showCamera}
          />
          <label for={'data-bytes'}>QR packet size (bytes):</label>
          <button className={'btn btn-primary'} onClick={this.toggleCamera}>
            Toggle Camera
          </button>
          <input
            ref={this.inputRef}
            type={'number'}
            name={'data-bytes'}
            value={this.state.dataBytes}
            min={1}
            max={10000}
            onChange={this.updateDataBytes}
          />
        </div>
      );
    }
    return (
      <div>
        <p>Send page</p>
        {maybeQr}
      </div>
    );
  }
}

export default Send;
